var text_field_default = {
  "root": "Tefm2",
  "text": "_3-KN8",
  "input": "b8p5k",
  "small": "_7BYJ7",
  "medium": "aD3-f",
  "large": "jIkhZ",
  "webview": "cgz9d",
  "endAdornment": "e8wY2",
  "shown": "g16nt",
  "value": "KDOV7",
  "spinner": "GirPz",
  "spin": "Ab-Kc"
};
export {
  text_field_default as default
};
//# sourceMappingURL=text-field-scss.js.map
